RecalculateModalBodyMixin     = require 'mixins/recalculate-modal-body'

App.SmModalDialogComponent = Em.Component.extend RecalculateModalBodyMixin,
  classNames: [ 'sm-modal-dialog' ]
  size: ''

  isOpen: false

  didInsertElement: ->
    Em.$('body').addClass('modal-open')
    Em.run.next =>
      return if @get('isDestroyed')
      @set('isOpen', true)

  willDestroyElement: ->
    Em.$('body').removeClass('modal-open')

  closableByOverlay: true


  mouseDown: (event) ->
    @set 'targetWasOverlay', Em.$(event.target).is(@$('.modal-overlay'))

  # Нажатие на оверлей должно закрывать модальное окно
  # Чтобы отключить это поведение, нужно переопределить флаг 'closableByOverlay'
  click: (event) ->
    target = Em.$(event.target)
    allowOverlayClose = target.is(@$('.modal-overlay')) and @get('targetWasOverlay') and @get('closableByOverlay')
    targetIsCloseButton = target.is(@$('.close-button'))

    if allowOverlayClose or targetIsCloseButton
      @sendAction('overlayClicked')

    @_super(arguments...)

